import { Box, Collapse, Hidden, Link, Tooltip } from '@material-ui/core';
import { NavLink } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import Grid from '@material-ui/core/Grid';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import React, { Fragment } from 'react';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import clsx from 'clsx';
import { AngleLeftIcon, AngleRightIcon } from '../../components/Icons';
import { Typography } from '../../components/Typography';
import Brand from '../../components/Brand';
const useStyles = makeStyles(({ palette, spacing, transitions, typography }) => ({
    item: {
        paddingTop: spacing(2),
        paddingBottom: spacing(2),
        fontSize: 20,
        textDecoration: 'none',
        color: palette.text.primary,
    },
    hoverableItem: {
        '&:hover,&:focus': {
            backgroundColor: palette.background.default,
        },
    },
    menuItem0Contracted: {
        paddingLeft: 17,
        transition: transitions.create('padding-left', {
            easing: transitions.easing.sharp,
            duration: transitions.duration.enteringScreen,
        }),
    },
    menuItem0Expanded: {
        transition: transitions.create('padding-left', {
            easing: transitions.easing.sharp,
            duration: transitions.duration.leavingScreen,
        }),
    },
    logo: {
        paddingTop: spacing(2),
        paddingBottom: spacing(2),
        fontSize: 23,
        '&:hover': {
            cursor: 'default',
        },
    },
    logoDivider: {
        fontSize: '30px',
        fontWeight: 500,
        background: '#e0e0e0',
        width: '1px',
        transform: 'scaleX(0.5)',
        height: '30px',
        display: 'inline-block',
        margin: '0 16px',
    },
    itemActiveItem: {
        '& > *': {
            color: palette.secondary.main,
            '& > *': {
                color: `${palette.secondary.main} !important`,
            },
            '&:hover,&:focus': {
                backgroundColor: palette.background.default,
            },
        },
    },
    itemIcon: {
        fontSize: 22,
        minWidth: 'auto',
        marginRight: spacing(3),
        color: palette.text.secondary,
    },
    minimizeButton: {
        fontSize: 22,
        margin: '5px -10px 5px 0',
        color: palette.text.secondary,
    },
    drawerOpen: {
        width: 256,
        overflowX: 'hidden',
        transition: transitions.create('width', {
            easing: transitions.easing.sharp,
            duration: transitions.duration.enteringScreen,
        }),
    },
    drawerClose: {
        overflowX: 'hidden',
        transition: transitions.create('width', {
            easing: transitions.easing.sharp,
            duration: transitions.duration.leavingScreen,
        }),
        width: spacing(7) + 1,
    },
    arrowContracted: {
        '& > i': {
            transform: 'rotate(-180deg)',
            transition: transitions.create('transform', {
                easing: transitions.easing.sharp,
                duration: transitions.duration.enteringScreen,
            }),
        },
    },
    arrowExpanded: {
        '& > i': {
            transition: transitions.create('transform', {
                easing: transitions.easing.sharp,
                duration: transitions.duration.enteringScreen,
            }),
        },
    },
    afterItemsContracted: {
        paddingLeft: spacing(1),
        paddingRight: spacing(1),
        transition: transitions.create('padding', {
            easing: transitions.easing.sharp,
            duration: transitions.duration.enteringScreen,
        }),
    },
    afterItemsExpanded: {
        transition: transitions.create('padding', {
            easing: transitions.easing.sharp,
            duration: transitions.duration.enteringScreen,
        }),
    },
}));
export const Navigator = (props) => {
    const { singleOpenItem, navigatorItems, navigatorState, toggleNavigator, navigatorAfterItems, navigatorFooter, navigatorHeader, logoUrl, appTitle = 'Forge', ...other } = props;
    const [openTabs, setOpenTabs] = React.useState(new Map());
    const isDesktopOpen = navigatorState === 'desktop-full';
    const mobileOpen = navigatorState === 'drawer-open';
    const classes = useStyles();
    const classHierarchy = [
        {
            contracted: classes.menuItem0Contracted,
            expanded: classes.menuItem0Expanded,
        },
        {
            contracted: '',
            expanded: '',
        },
    ];
    const closeExceptId = (id, items) => {
        items
            .filter(e => e.id !== id)
            .forEach(e => {
            e.children && closeExceptId(id, e.children);
            openTabs.set(e.id, false);
        });
    };
    const toggleItem = (id) => {
        if (singleOpenItem) {
            setOpenTabs(new Map([[id, !!openTabs.get(id)]]));
            closeExceptId(id, navigatorItems || []);
        }
        else {
            openTabs.set(id, !openTabs.get(id));
            setOpenTabs(new Map(openTabs));
        }
    };
    const nestedMenu = (isMobile, isContracted, level, opts) => {
        const optWrapInNavLink = (item) => !opts.to ? (item) : (React.createElement(NavLink, { activeClassName: classes.itemActiveItem, to: opts.to, exact: opts.exact, className: clsx(classes.item, classes.hoverableItem) }, item));
        return (React.createElement(Fragment, { key: opts.id },
            optWrapInNavLink(
            // Tooltip title. Zero-length titles string are never displayed.
            React.createElement(Tooltip, { title: !isDesktopOpen && !isMobile ? opts.id : '', placement: "right" },
                React.createElement(ListItem, { button: true, className: clsx(classes.item, !isMobile && {
                        [classHierarchy[level].contracted]: isContracted,
                        [classHierarchy[level].expanded]: !isContracted,
                    }), onClick: () => toggleItem(opts.id) },
                    opts.icon && React.createElement(ListItemIcon, { className: clsx(classes.itemIcon) }, opts.icon),
                    React.createElement(ListItemText, { disableTypography: true },
                        React.createElement(Typography, { variant: "h6" }, opts.id))))),
            opts.children && (React.createElement(Collapse, { in: openTabs.get(opts.id), timeout: "auto", unmountOnExit: true }, (opts.children || []).map(e => nestedMenu(isMobile, isContracted, level + 1, e))))));
    };
    const getDrawerItems = (isMobile) => (React.createElement(React.Fragment, null,
        React.createElement(List, { disablePadding: true },
            React.createElement(Box, { my: 1 },
                React.createElement(ListItem, { className: clsx(classes.item, classes.logo, !isMobile && {
                        [classHierarchy[0].contracted]: !isDesktopOpen,
                        [classHierarchy[0].expanded]: isDesktopOpen,
                    }) },
                    React.createElement(Link, { underline: "none", href: logoUrl || window.location.origin },
                        React.createElement(Brand, null, appTitle)))),
            navigatorHeader && (React.createElement(Box, { display: "flex", justifyContent: "center", mb: 2 }, navigatorHeader(isDesktopOpen, isMobile))),
            (navigatorItems || []).map(e => nestedMenu(isMobile, !isDesktopOpen, 0, e)),
            navigatorAfterItems && (React.createElement(Box, { mt: 4 },
                React.createElement(ListItem, { className: clsx(!isMobile && {
                        [classHierarchy[0].contracted + ' ' + classes.afterItemsContracted]: !isDesktopOpen,
                        [classHierarchy[0].expanded + ' ' + classes.afterItemsExpanded]: isDesktopOpen,
                    }) }, navigatorAfterItems)))),
        React.createElement(Grid, { item: true, xs: true }),
        navigatorFooter && (React.createElement(Box, { display: "flex", justifyContent: "center", mb: 2 }, navigatorFooter(isDesktopOpen, isMobile))),
        !isMobile && (React.createElement(ListItem, { "aria-label": "Open drawer", button: true, onClick: toggleNavigator, className: clsx(!isMobile && {
                [classes.item]: true,
                [classHierarchy[0].contracted + ' ' + classes.arrowContracted]: !isDesktopOpen,
                [classHierarchy[0].expanded + ' ' + classes.arrowExpanded]: isDesktopOpen,
            }) },
            React.createElement(Grid, { xs: true, item: true }),
            isDesktopOpen ? (React.createElement(AngleLeftIcon, { className: classes.minimizeButton })) : (React.createElement(AngleRightIcon, { className: classes.minimizeButton }))))));
    return (React.createElement(React.Fragment, null,
        React.createElement(Hidden, { smUp: true, implementation: "js" },
            React.createElement(SwipeableDrawer, Object.assign({}, other, { open: mobileOpen, onClose: toggleNavigator, onOpen: toggleNavigator, ModalProps: {
                    keepMounted: true,
                } }), getDrawerItems(true))),
        React.createElement(Hidden, { xsDown: true, implementation: "css" },
            React.createElement(Drawer, Object.assign({}, other, { className: clsx({
                    [classes.drawerOpen]: isDesktopOpen,
                    [classes.drawerClose]: !isDesktopOpen,
                }), classes: {
                    paper: clsx({
                        [classes.drawerOpen]: isDesktopOpen,
                        [classes.drawerClose]: !isDesktopOpen,
                    }),
                }, variant: "permanent", open: isDesktopOpen }), getDrawerItems(false)))));
};
//# sourceMappingURL=Navigator.js.map